<template>
  <div class="main-schedule">
    <my-header
      :page_name="$t('navigation.headerTitles.scheduler')"
      show_usermenu
    ></my-header>
    <el-dialog
      :title="$t('scheduler.cronHelp')"
      :visible.sync="helpVisible"
      width="70%"
      custom-class="more-info-dialog"
    >
      <div class="more-info__inner">
        <b> {{ $t("scheduler.schedulerStructure") }}</b>
        <ul class="info-list">
          <li>
            {{ $t("scheduler.schedulerConsistOfPackeges") }}
          </li>
          <li>
            {{ $t("scheduler.eachPackageConsistsOfAnArbitraryNumber") }}
            <ul class="info-list-inner">
              <li>
                {{ $t("scheduler.stepIsATemplateThatWorksWithSpecificTasks") }}
              </li>
            </ul>
          </li>
          <li>
            {{ $t("scheduler.stepCreate") }}
            <ul class="info-list-inner">
              <li>{{ $t("scheduler.forStepCreateNeedSelectApp") }}</li>
              <li>
                {{
                  $t(
                    "scheduler.AfterThatListOfTemplatesCreatedForThisWillAppear"
                  )
                }}
              </li>
              <li>
                {{
                  $t(
                    "scheduler.ifNeededSelectBaseYouNeedSelectItFromCurrentList"
                  )
                }}
              </li>
            </ul>
          </li>
          <li>
            {{ $t("scheduler.stepEdit") }}
            <ul class="info-list-inner">
              <!-- <li>
                {{ $t("scheduler.stepEditError") }}
              </li> -->
              <li>
                {{ $t("scheduler.stepsCanBeRearranged") }}
              </li>
            </ul>
          </li>
          <li>
            {{ $t("scheduler.stepsEditWarning") }}
          </li>
          <li>
            {{ $t("scheduler.packageCanHaveOneSchedule") }}
            <ul class="info-list-inner">
              <li>
                {{ $t("scheduler.packagesCanBeSortedByNameOrDate") }}
              </li>
            </ul>
          </li>
          <br />
        </ul>
        <b>{{
          $t("scheduler.newChanges") +
          "(" +
          $t("scheduler.newChanges") +
          "0.9.11):"
        }}</b>
        <ul class="info-list">
          <li>
            {{ $t("scheduler.nowYouCanCreateTasksCopy") }}
            <ul class="info-list-inner">
              <li>
                {{ $t("scheduler.allBasesAndQuanityAdded") }}
              </li>
              <li>
                {{ $t("scheduler.allBasesElementCanCreateAllCopiesOfTasks") }}
              </li>
              <li>
                {{ $t("scheduler.quanityElementCreateCopiesOfCurrentTask") }}
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </el-dialog>
    <el-dialog
      :title="$t('scheduler.cronExportPreview')"
      width="70%"
      center
      :visible.sync="previewVisible"
      v-if="cronPreview"
      custom-class="more-info-dialog"
      @close="cancelCronSave"
      ><div class="cron-preview-contents more-info__inner">
        {{ cronPreview }}
      </div>
      <div class="bottom-buttons">
        <div></div>
        <div>
          <el-button type="plain" @click="cancelCronSave">{{
            $t("scheduler.cancel")
          }}</el-button>
          <el-button type="primary" @click="confirmCronSave">{{
            $t("scheduler.export")
          }}</el-button>
        </div>
      </div>
    </el-dialog>
    <div class="settings-line">
      <div class="settings-element">
        <label>{{ $t("scheduler.server") }}</label>
        <el-select v-model="serverSelected" @change="serverChanged" filterable>
          <el-option
            v-for="(server, index) in getServersArray"
            :key="index"
            :value="server.id"
            :label="server.name"
          ></el-option>
        </el-select>
        <el-button
          @click="createCronClick"
          class="btn"
          v-if="cron && !cron.id"
          size="mini"
          >{{ $t("scheduler.cronCreate") }}</el-button
        >
      </div>
      <div class="settings-element">
        <el-button class="el-icon-question btn" @click="helpClick"></el-button>
        <el-button
          @click="exportCronClick"
          class="btn"
          :type="buttonType"
          v-if="serverSelected && cron && cron.id"
          >{{ $t("scheduler.cronExport") }}</el-button
        >

        <el-button  v-if="getUser && +getUser.roleid <= 1 && getUser.roletype === '0'" @click="backupBase" class="el-icon-upload left btn">{{
          $t("navigation.userMenu.backup")
        }}</el-button>
      </div>
    </div>
    <div class="main-transfer">
      <el-tabs
        type="border-card"
        v-if="
          cron &&
          cron.id &&
          cronTemplates &&
          cronTemplates.length >= 0 &&
          cronPackets &&
          cronPackets.length >= 0
        "
      >
        <el-tab-pane :label="$t('scheduler.cronEdit')">
          <packets></packets>
        </el-tab-pane>
        <el-tab-pane :label="$t('scheduler.templatesEdit')">
          <templates></templates>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Header from "../../components/reusable/header/Header";
import Templates from "../../components/cron/Templates";
import Packets from "../../components/cron/Packets";
import { mapGetters } from "vuex";
import i18n from "@/locales";
import moment from "moment";
export default {
  data() {
    return {
      // CRON
      serverSelected: null,
      helpVisible: false,
      previewVisible: false,
      cronPreview: null,
      buttonType: "default",
    };
  },
  methods: {
    /*--------------------- CRON ------------------- */
    serverChanged() {
      this.$store.commit("setLoading", true);
      this.$store.commit("setCronServer", this.serverSelected);
      this.$store
        .dispatch("getCron", this.serverSelected)
        .then((result) => {
          // console.log("cron ", result);
          if (result.id) {
            return this.$store.dispatch("getCronPackets");
          } else {
            this.$store.commit("setCronPackets", []);
            this.$store.commit("setCronTemplates", []);
            this.$message(this.$t("scheduler.onCurrentServerCronNotFound"));
            this.$store.commit("setLoading", false);
          }
        })
        .then(() => {
          return this.$store.dispatch("getCronTemplatesList");
        })
        .then(() => {
          return this.$store.dispatch("getApps", {
            serverSelected: this.serverSelected,
          });
        })
        .then(() => {
          // console.log("IN CHANGED SERVER");
          // this.markUnsavedJobs();
          this.$localStorage.set(
            "wa-cron",
            JSON.stringify(this.serverSelected)
          );
          this.$store.commit("setLoading", false);
        })
        .catch((error) => {
          // console.log("error", error);
          this.$store.commit("setError", error);
          this.$store.commit("setLoading", false);
        });
    },
    createCronClick() {
      this.$store.commit("setLoading", true);
      this.$store
        .dispatch("createCron", this.serverSelected)
        .then(() => {
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    cancelCronSave() {
      this.previewVisible = false;
      this.cronPreview = null;
    },
    exportCronClick() {
      this.$store.commit("setLoading", true);
      this.$store
        .dispatch("previewExportCron", this.cron.id)
        .then((result) => {
          this.$store.commit("setLoading", false);
          this.cronPreview = result;
          this.previewVisible = true;
        })
        .catch((error) => {
          this.$store.commit("setLoading", false);
        });
    },
    confirmCronSave() {
      this.$store.commit("setLoading", true);
      this.$store
        .dispatch("exportCron", this.cron.id)
        .then(() => {
          this.$store.commit("setLoading", false);
          this.previewVisible = false;
          this.cronPreview = null;
          return this.$store.dispatch("getCron", this.serverSelected);
        })
        .then((result) => {
          this.changeExportCron(result);
        })
        .catch((error) => {
          this.$store.commit("setLoading", false);
        });
    },
    changeExportCron(cron) {
      const dateEdit = moment(cron.dateEdit);
      const dateSave = moment(cron.dateSave);
      if (!dateSave.isValid() && dateEdit.isValid() ||dateSave.isValid() && dateEdit.isValid() && dateSave.isBefore(dateEdit)) {
        this.$message(i18n.t("scheduler.cronNotExported"));
        this.buttonType = "danger";
      } else this.buttonType = "default";
    },
    helpClick() {
      this.helpVisible = true;
    },
    backupBase() {
      this.$store.commit("setLoading", true);
      this.$store
        .dispatch("backupBase")
        .then(() => {
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
  },
  components: {
    myHeader: Header,
    Packets,
    Templates,
  },
  watch: {
    cron(cur) {
      this.changeExportCron(cur);
    },
  },
  created() {
    let server = JSON.parse(this.$localStorage.get("wa-cron"));
    if (server) {
      if (!this.getServersArray.find((s) => s.id === server)) {
        return;
      }
      this.serverSelected = server;
      this.serverChanged();
    }
  },
  computed: {
    ...mapGetters(["getServersArray", "cron", "cronPackets", "cronTemplates", "getUser"]),
  },
};
</script>


<style scoped>
.settings-line {
  display: flex;
  justify-content: space-between;
  padding-right: 0px !important;
}
.settings-element {
  margin-right: 0px !important;
}
.el-button.btn {
  margin-top: 2px;
}
.el-select {
  width: 100% !important;
}
.main-transfer {
  background: var(--main-background);
  margin-left: 5px;
  padding-bottom: 5px;
}
.info-list {
  list-style: disc inside none;
  margin-left: 10px;
}
.info-list-inner {
  list-style: circle inside none;
}
li {
  margin-left: 5px;
}
.more-info__inner {
  word-break: normal;
}
.cron-preview-contents {
  white-space: pre;
  font-family: "Roboto Mono", monospace;
}
</style>